import './customerProfileView.scss';
import { useOutletContext, useNavigate } from 'react-router-dom';
import { ROUTES } from '@/utils/constants/routesConstants';
import { DataTable, Icon } from 'pepsico-ds';

import InfoPanel from '@/components/common/InfoPanel/InfoPanel';
import InfoItem from '@/components/common/InfoItem/InfoItem';
import CustomerAddressInfoItem from '@/components/common/CustomerAddressInfoItem/CustomerAddressInfoItem';

const normalizeGender = gender => {
  if (!gender) return null;
  const lowerCaseGender = gender.toLowerCase();
  if (lowerCaseGender === 'm' || lowerCaseGender === 'male') return 'Male';
  if (lowerCaseGender === 'f' || lowerCaseGender === 'female') return 'Female';
  return null;
};

const ProfileView = () => {
  const { customerData } = useOutletContext();

  const navigate = useNavigate();

  /**
   * Handles navigation to the customer view page when a customer ID is clicked
   * This function takes a customer ID and navigates to the customer view route
   * by replacing the :customerId parameter in the route with the actual ID
   *
   * @param {string} customerId - The ID of the customer to view
   */
  const handleCustomerClick = customerId => {
    navigate(ROUTES.CUSTOMER_VIEW.replace(':customerId', customerId));
  };

  const handleStoreClick = storeId => {
    navigate(ROUTES.STORE_VIEW.replace(':storeId', storeId));
  };

  const columns = [
    {
      columnKey: 'storeId',
      header: 'Store ID',
      cellData: ctx => {
        return (
          <p
            className='cursor-pointer text-[#3387DF] font-bold'
            onClick={() => handleStoreClick(ctx.row.original.storeId)}>
            {ctx.row.original.storeId}
          </p>
        );
      }
    },
    {
      columnKey: 'storeName',
      header: 'Store Name',
      cellData: ctx => {
        return ctx.row.original.storeName || '-';
      }
    },
    {
      columnKey: 'points',
      header: 'Current Points'
    }
  ];
  console.log(customerData);
  return (
    <>
      {customerData.customerInformation.oktaStatus === 'Deprovisioned' && (
        <div className='bg-[#00152B] mb-6 rounded pt-2 w-[403px] h-[92px] border border-[#0069D7]'>
          <div className='flex items-start px-4'>
            <div className='text-blue-400 mr-3 mt-1'>
              <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <circle cx='8' cy='8' r='8' fill='#3387DF' />
                <path
                  d='M8.92 11.5H7.08V5.96H8.92V11.5ZM8 4.9C7.76 4.9 7.55 4.82 7.39 4.66C7.23 4.5 7.15 4.3 7.15 4.06C7.15 3.82 7.23 3.62 7.39 3.46C7.55 3.3 7.76 3.22 8 3.22C8.24 3.22 8.45 3.3 8.61 3.46C8.77 3.62 8.85 3.82 8.85 4.06C8.85 4.3 8.77 4.5 8.61 4.66C8.45 4.82 8.24 4.9 8 4.9Z'
                  fill='white'
                />
              </svg>
            </div>
            <div className='text-white'>
              <h3 className='text-[16px] font-medium mb-1'>
                Okta Status Deprovisioned
              </h3>
              <p className='text-sm text-white'>
                User requested a phone number change and has not reset their
                password for 10 days
              </p>
            </div>
          </div>
        </div>
      )}

      <div className='bg-gray-850 rounded-lg py-4'>
        <InfoPanel
          title='Customer Information'
          isCollapsible={false}
          defaultOpen={true}>
          <div className='space-y-6 px-4 text-sm'>
            <div className='grid grid-cols-3 gap-y-6'>
              <InfoItem
                label='IDP ID'
                value={customerData?.customerInformation?.idpId}
              />
              <InfoItem
                label='Gender'
                value={normalizeGender(
                  customerData?.customerInformation?.gender
                )}
              />
              <InfoItem
                label='Date of Birth'
                value={customerData?.customerInformation?.dateOfBirth}
              />
              <InfoItem
                label='Email'
                value={customerData?.customerInformation?.email}
              />

              <div>
                <InfoItem
                  label='Phone'
                  value={customerData?.customerInformation?.phoneNumber}
                />
                {customerData?.customerInformation?.oktaStatus ===
                  'Deprovisioned' && (
                  <div className='mt-2 w-[149px] h-[20px] text-[10px] bg-[#DB3333] text-white rounded flex items-center justify-center'>
                    OKTA Status:{' '}
                    <span className='ml-1 capitalize'>
                      {customerData?.customerInformation?.oktaStatus}
                    </span>
                  </div>
                )}
              </div>

              <InfoItem
                label='Alternative Phone'
                value={
                  customerData?.customerInformation?.alternativePhoneNumber
                }
              />

              <InfoItem
                label='Last Login'
                value={customerData?.customerInformation?.lastLoginDate}
              />

              <InfoItem
                label='Login Expiration'
                value={customerData?.customerInformation?.loginExpirationDate}
              />

              <InfoItem
                label='Preferred Language'
                value={customerData?.customerInformation?.preferredLanguage}
              />
            </div>
            <CustomerAddressInfoItem
              address={customerData?.customerInformation?.address}
              customerInfo={customerData?.customerInformation}
            />
          </div>
        </InfoPanel>

        <InfoPanel title='Stores' isCollapsible={false} defaultOpen={true}>
          <div className='admin-profile_stores-table-container'>
            <DataTable
              tableHeader=''
              tableDescription=''
              showColumnFilters={false}
              showGlobalActions={false}
              columns={columns}
              data={customerData?.stores}
              pageSize={500}
            />
          </div>
        </InfoPanel>
      </div>
    </>
  );
};

export default ProfileView;
